<ng-container *transloco="let t; prefix: 'configuration-collection-selector-component'">
  <div class="configuration-collection-selector__container xi-modal__container">
    <div class="kxi-text-center configuration-collection-selector__text">
      <h2 class="xi-modal__title">{{ t('title') }}</h2>
      <p class="kxi-text-medium">
        {{ t('size-warning') }}
      </p>
      <p class="kxi-text-medium">
        {{ t('section-size-warning') }}
      </p>
    </div>

    @if (isLoading()) {
      <div class="configuration-collection-selector__loading">
        <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
      </div>
    } @else {
      <div class="configuration-collection-selector__content xi-modal__content">
        <app-lex-xi-tree-picker [items]="items()" (onItemsChanged)="onCollectionSelected($event)">
        </app-lex-xi-tree-picker>
      </div>
    }

    <div class="configuration-collection-selector__actions xi-modal__actions">
      <xi-default-button
        buttonSize="large"
        text="{{ t('cancel') }}"
        fill="text"
        (onClick)="cancel()"
      ></xi-default-button>

      <xi-default-button
        text="{{ t('continue') }}"
        buttonSize="large"
        [disabled]="!confirmable()"
        (onClick)="confirm()"
      ></xi-default-button>
    </div>
  </div>
</ng-container>
